const embeddedFormsIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2.625C0 1.17525 1.23122 0 2.75 0H18.25C19.7688 0 21 1.17525 21 2.625V14.5568C21 14.9522 20.6642 15.2727 20.25 15.2727C19.8358 15.2727 19.5 14.9522 19.5 14.5568V2.625C19.5 1.96602 18.9404 1.43182 18.25 1.43182H2.75C2.05964 1.43182 1.5 1.96602 1.5 2.625V18.375C1.5 19.034 2.05964 19.5682 2.75 19.5682H11.4512C11.8654 19.5682 12.2012 19.8887 12.2012 20.2841C12.2012 20.6795 11.8654 21 11.4512 21H2.75C1.23122 21 0 19.8247 0 18.375V2.625Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2.625C0 1.17525 1.23122 0 2.75 0H18.25C19.7688 0 21 1.17525 21 2.625V14.5568C21 14.9522 20.6642 15.2727 20.25 15.2727C19.8358 15.2727 19.5 14.9522 19.5 14.5568V2.625C19.5 1.96602 18.9404 1.43182 18.25 1.43182H2.75C2.05964 1.43182 1.5 1.96602 1.5 2.625V18.375C1.5 19.034 2.05964 19.5682 2.75 19.5682H11.4512C11.8654 19.5682 12.2012 19.8887 12.2012 20.2841C12.2012 20.6795 11.8654 21 11.4512 21H2.75C1.23122 21 0 19.8247 0 18.375V2.625Z"
      fill="#6B00DF"
    />
    <path
      d="M3.58537 17.1585C3.58537 16.7342 3.92934 16.3902 4.35366 16.3902H7.42683C7.85115 16.3902 8.19512 16.7342 8.19512 17.1585C8.19512 17.5829 7.85115 17.9268 7.42683 17.9268H4.35366C3.92934 17.9268 3.58537 17.5829 3.58537 17.1585Z"
      fill="#6B00DF"
    />
    <path
      d="M3.58537 3.84146C3.58537 3.41715 3.92934 3.07317 4.35366 3.07317H16.6463C17.0707 3.07317 17.4146 3.41715 17.4146 3.84146C17.4146 4.26578 17.0707 4.60976 16.6463 4.60976H4.35366C3.92934 4.60976 3.58537 4.26578 3.58537 3.84146Z"
      fill="#6B00DF"
    />
    <path
      d="M3.58537 6.91463C3.58537 6.49032 3.92934 6.14634 4.35366 6.14634H16.6463C17.0707 6.14634 17.4146 6.49032 17.4146 6.91463C17.4146 7.33895 17.0707 7.68293 16.6463 7.68293H4.35366C3.92934 7.68293 3.58537 7.33895 3.58537 6.91463Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.58537 10.628C3.58537 9.85014 4.33263 9.21951 5.25442 9.21951H15.7456C16.6674 9.21951 17.4146 9.85014 17.4146 10.628V13.4451C17.4146 14.223 16.6674 14.8537 15.7456 14.8537H5.25442C4.33262 14.8537 3.58537 14.223 3.58537 13.4451V10.628ZM5.25442 10.4268C5.12273 10.4268 5.01598 10.5169 5.01598 10.628V13.4451C5.01598 13.5563 5.12273 13.6463 5.25442 13.6463H15.7456C15.8773 13.6463 15.984 13.5563 15.984 13.4451V10.628C15.984 10.5169 15.8773 10.4268 15.7456 10.4268H5.25442Z"
      fill="#6B00DF"
    />
    <path
      d="M12.9483 19.0837C12.8605 19.0407 12.8049 18.9515 12.8049 18.8537V18.4379C12.8049 18.3402 12.8605 18.2509 12.9483 18.2079L15.0809 17.1636C15.251 17.0803 15.4496 17.2042 15.4496 17.3936V17.6629C15.4496 17.764 15.3902 17.8556 15.2979 17.8968L13.6589 18.6285C13.6525 18.6314 13.6461 18.6244 13.6496 18.6183C13.6532 18.6117 13.6633 18.6143 13.6633 18.6218V18.6698C13.6633 18.6774 13.6532 18.68 13.6496 18.6734C13.6461 18.6672 13.6525 18.6603 13.6589 18.6631L15.2979 19.3949C15.3902 19.4361 15.4496 19.5277 15.4496 19.6287V19.898C15.4496 20.0875 15.251 20.2113 15.0809 20.128L12.9483 19.0837Z"
      fill="#6B00DF"
    />
    <path
      d="M17.5413 15.878C17.7071 15.878 17.8292 16.0332 17.7902 16.1944L16.6744 20.8041C16.6466 20.9191 16.5438 21 16.4255 21H16.2631C16.0973 21 15.9752 20.8448 16.0142 20.6837L17.13 16.0739C17.1578 15.959 17.2607 15.878 17.3789 15.878H17.5413Z"
      fill="#6B00DF"
    />
    <path
      d="M21 18.8537C21 18.9515 20.9443 19.0407 20.8565 19.0837L18.724 20.128C18.5539 20.2113 18.3553 20.0875 18.3553 19.898V19.6287C18.3553 19.5277 18.4147 19.4361 18.507 19.3949L20.1459 18.6631C20.1524 18.6603 20.1587 18.6672 20.1553 18.6734C20.1516 18.68 20.1416 18.6774 20.1416 18.6698V18.6218C20.1416 18.6143 20.1516 18.6117 20.1553 18.6183C20.1587 18.6244 20.1524 18.6314 20.1459 18.6285L18.507 17.8968C18.4147 17.8556 18.3553 17.764 18.3553 17.6629V17.3936C18.3553 17.2042 18.5539 17.0803 18.724 17.1636L20.8565 18.2079C20.9443 18.2509 21 18.3402 21 18.4379V18.8537Z"
      fill="#6B00DF"
    />
  </svg>
);

export { embeddedFormsIcon };
